<div class="container">
  <div class="icon" *ngIf="icon">
    <mat-icon *ngIf="status == 0">priority_high</mat-icon>
    <mat-icon *ngIf="status == 1">information</mat-icon>
    <mat-icon *ngIf="status == 2">error</mat-icon>
  </div>
  <div class="content">
    <p><ng-content></ng-content></p>
  </div>
</div>